const footer = {
	call_tips:'联系我们',
	adress:' 中国有色金属行业EPD平台办公室地址：北京市海淀区复兴路乙12号',
	postcode:'邮政编码：100038',
	call:'客服热线：010-63971471 周一至周五：8:30-17:00',
	ICP_tips:'IP备案号',
	ICP1:'京ICP备17052534号',
	ICP2:'京公网安备11040102700068号'
}

export default footer